import React, { useEffect, useState } from 'react';
import { Tabs } from 'antd';
import TableInvoice from './TableInvoice';

const InvoiceStatus = ({ dataSource }) => {
    const [data, setData] = useState([]);

    useEffect(() => {
        if (dataSource && dataSource.length > 0) {
            setData(dataSource);
        }
    }, [dataSource]);

    // Filter data
    const dataOutStanding = data.filter((item) => item.DashboardStatus === "OutStanding Payment");
    const dataOverdue = data.filter((item) => item.DashboardStatus === "Overdue Payment");
    const dataPaid = data.filter((item) => item.DashboardStatus === "Paid");

    // Hitung total per tab
    const outstandingTotal = dataOutStanding.length;
    const overdueTotal = dataOverdue.length;
    const paidTotal = dataPaid.length;

    const items = [
        {
            key: '1',
            label: `Outstanding (${outstandingTotal})`,
            children: <TableInvoice dataSource={dataOutStanding} />,
        },
        {
            key: '2',
            label: `Overdue (${overdueTotal})`,
            children: <TableInvoice dataSource={dataOverdue} />,
        },
        {
            key: '3',
            label: `Paid (${paidTotal})`,
            children: <TableInvoice dataSource={dataPaid} />,
        },
    ];

    return (
        <div className="w-full bg-white p-4 rounded-md">
            <div className="flex justify-between items-center">
                <p className="text-2xl font-medium">INVOICE STATUS</p>
                <p>Total All Items: {data.length}</p>
            </div>
            <Tabs defaultActiveKey="1" items={items} />
        </div>
    );
};

export default InvoiceStatus;